import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <span className="tree-icon">🌲</span> Jingle Texts
      </Link>
      
      <div className="navbar-nav">
        {isAuthenticated ? (
          <>
            <Link to="/dashboard" className="nav-link">Dashboard</Link>
            <Link to="/send" className="nav-link">Send Message</Link>
            <Link to="/history" className="nav-link">History</Link>
            {user?.isAdmin && (
              <Link to="/admin" className="nav-link" style={{ color: 'var(--christmas-gold)' }}>
                🔧 Admin
              </Link>
            )}
            <Link to="/credits" className="nav-link">
              <span className="credits-badge">
                📩 {user?.credits || 0} SMS
              </span>
            </Link>
            <button onClick={handleLogout} className="btn btn-outline">
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="nav-link">Login</Link>
            <Link to="/signup" className="btn btn-primary">
              Get Started
            </Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
